// filepath: c:/Develop/Cellcom.Digital.Cms/src/Spa.Frontend/src/Components/Block/RouterSelfInstallBlock/index.tsx
import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OpeningHoursGuideReferralBlockData from 'Models/Content/OpeningHoursGuideReferralBlockData';
import OpeningHoursReferralMain from './main';
export default class OpeningHoursGuideReferralBlock extends EpiComponent<OpeningHoursGuideReferralBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <OpeningHoursReferralMain iContent={this.props.data} context={this.getContext()} />;
  }
}
